<template>
  <div class="api-auth">
    <navigation :customClickEvent="true" @click="backAction">
      {{info.productName}}
      <template v-slot:right>
        <div class="home-button" @click="backToHome">返回首页</div>
      </template>
    </navigation>
    <pulldown-page
      :refresh="init"
      :is-scroll="true"
      class="home"
      background="#F7F7F7"
      color="#333333"
    >
      <main>
        <!-- 授信审核中 -->
        <template v-if="result==='IN_HANDLE'">
          <div class="status wait">
            <div class="wait-lottie">
              <vue-lottie class="" :options="lottieOptions"></vue-lottie>
            </div>
            <h2>加急审核中</h2>
            <p class="expt">
              {{info.productName}}-为您提供本次金融服务
            </p>
            <div class="refresh" @click="refreshAction">刷新结果</div>
          </div>
        </template>

        <!-- 授信审核成功 -->
        <template v-if="result==='SUC'">
          <div class="status success">
            <div :class="['card', {isBack: cardFliped}]">
              <div class="front">
                <div class="info-header">
                  <div class="title">{{info.productName}}</div>
                  <img src="./images/icon_info.png" @click="cardFlip">
                </div>
                <p class="bottom-tip">为您提供本次金融服务</p>
                <!-- 产品信息卡片
                  1. 授信通过
                  2. 授信通过但额度失效 -->
                <div class="info">
                  <p class="status-title">{{amountInfo.statusTitle}}</p>
                  <h2 class="status-amount">{{amountInfo.statusAmount}}</h2>
                  <!-- api产品全流程 授信通过不可提现 <p class="credit-amount" v-if="!amountInfo.canWithDraw">总额度(元）{{amountInfo.tralAmount}}</p> -->
                  <div :class='["bottom-tags", {noCreditAmount:amountInfo.amountUpdateConfiged}]'>
                    <div class="tag">
                      <img src="./images/checkmark.png">
                      快速审批
                    </div>
                    <div class="tag">
                      <img src="./images/checkmark.png">
                      分期灵活
                    </div>
                    <div class="tag">
                      <img src="./images/checkmark.png">
                      利率低
                    </div>
                  </div>
                </div>
                <!-- api全流程 授信通过额度失效 <div v-else class="invalid">
                  <img src="./images/credit_amount_invalid.png">
                </div> -->
                <!-- 按钮状态
                  1. 授信通过可提现：立即提现 可点击
                  2. 授信通过不可提现：可用额度不满足产品最低提现金额 不可点击 半透明
                  3. 授信通过额度失效：额度已失效 灰色 -->
                <!-- 全流程 <div :class="['withdraw-btn', {disabled: !amountInfo.canWithDraw}]" @click="jump">
                  {{ amountInfo.canWithDraw ? '立即提现' : '可用额度不满足产品最低提现金额'}}
                </div> -->
                <div class="withdraw-btn" @click="jump">立即提现</div>
              </div>
              <product-info-card
                class="back"
                :productInfo="info"
                @infoClick="cardFlip"
              />
            </div>
            <p class="footer-txt">
              本产品不对在校学生提供服务 <br>
              贷款有风险  借款需谨慎
            </p>
          </div>
        </template>
        <!-- 授信拒绝 -->
        <template v-if="['REJ','FAIL'].includes(result)">
          <div class="status fail">
            <div class="risk-banner" v-if="riskBannerData.showBanner"  data-sensors-exposure-event-name="Element_Exposure" >
              <img :src="riskBannerData.image" class="exposure-banner" data-sensors-click @click="checkBannerRiskReport">
            </div>
            <div v-else>
              <div class="wait-lottie">
                <vue-lottie class="" :options="lottieOptions"></vue-lottie>
              </div>
              <h2>授信未通过</h2>
            </div>
            <p class="expt">很抱歉，您暂不符合平台的申请条件。如有您有疑问，请联系{{info.productName}}客服：{{info.servicePhone}}</p>
          </div>
          <div class="recommend" v-if="loanList.length">
            <h3 class="main-title">为您推荐更多优选产品</h3>
            <div class="list-container">
              <borrow-item
                showLoanCounts v-for="(item,index) in loanList" :key="index"
                :item="item"
                @on-borrow="borrowMoney(item, index)"
              />
            </div>
          </div>
        </template>
      </main>
    </pulldown-page>
    <nd-dialog v-model="backPopVisible"
               @close='riskBackPopHasBeenShown=true'
               :footer="false"
               closeBtn
    >
      <div class="risk-pop"
           data-sensors-exposure-event-name="Element_Exposure"
      >
        <div class="title">您有一份信用报告待领取</div>
        <img class="content" src="./images/risk_pop_content.png">
        <nd-button class="check-button" @click="checkPopupRiskReport">立即查看</nd-button>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import waitData from '@/assets/json/wait.json'
import failData from '@/assets/json/fail.json'
import VueLottie from 'vue-lottie'
import ProductInfoCard from './components/product-info-card.vue'
import { mapActions } from 'vuex'
import { getKey } from '@/assets/utils'
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'

export default {
  components: {
    VueLottie,
    'borrow-item': () => import('@/components/borrow-list/borrow-item.vue'),
    ProductInfoCard
  },
  name: 'apiAuth',
  data () {
    return {
      result: '',
      loanList: [],
      info: {},
      creditResultDetail: { remainLimit: 0 },
      waitData,
      failData,
      amountInfo: {
        statusTitle: '可用额度(元)',
        statusAmount: '0.00',
        canWithDraw: false
      },
      autoRefreshTimer: null,
      applyNo: this.$route.query.applyNo,
      autoRefreshCount: 0,
      cardFliped: false,
      riskBannerData: {}, // 是否展示风险报告banner
      backPopVisible: false, // 挽留弹窗展示标识
      riskBackPopHasBeenShown: false, // 是否已经展示过挽留弹窗
      popupUrl: null // 弹窗跳转链接
    }
  },
  computed: {
    lottieOptions () {
      return this.result === 'IN_HANDLE' ? { animationData: this.waitData } : { animationData: this.failData, loop: false }
    },
    shouldPopup () {
      return ['REJ', 'FAIL'].includes(this.result) && this.riskBannerData.showBanner && !this.riskBackPopHasBeenShown
    }
  },
  async mounted () {
    try {
      this.getList()
      await this.getProductInfo()
      await this.init()
      this.$bus.$emit('ready')
    } catch (e) {
      this.$bus.$emit('ready')
    }
  },
  beforeDestroy () {
    clearTimeout(this.autoRefreshTimer)
    this.autoRefreshTimer = null
  },
  methods: {
    ...mapActions('apiDiversion', ['creditResult', 'productInfo', 'creditResultRiskBanner', 'creditResultPopup']),
    ...mapActions('user', ['getBorrowList', 'getApiProductUrl']),
    async getList () {
      const { success, data } = await this.getBorrowList({
        showPlace: 'CREDIT_RESULT_API'
      })
      if (success) {
        this.loanList = data.configs || []
      }
    },
    async jump () {
      const configIds = getKey('configIds')
      this.$sensors.track('Withdraw_Element_Click', { product_type: 'diversion', page_status: 'SUC', product_code: configIds[0] })
      const { success, data } = await this.getApiProductUrl({
        configId: configIds[0],
        unionType: 'LOAN'
      })
      if (success && data.url) {
        window.location.href = data.url
      }
    },
    async getRiskBanner () {
      const { success, data } = await this.creditResultRiskBanner()
      if (success) {
        this.riskBannerData = data || {}
        if (this.shouldPopup) {
          this.getPopupData()
        }
      }
    },
    async getPopupData () {
      const { success, data } = await this.creditResultPopup()
      if (success && data && data.url) {
        this.popupUrl = data.url
      }
    },
    async getCreditResult () {
      const configIds = getKey('configIds')
      const { success, data } = await this.creditResult({
        configId: configIds[0],
        applyNo: this.applyNo
      })
      if (success) {
        this.result = data.creditStatus
        if (['REJ', 'FAIL'].includes(data.creditStatus)) {
          await this.getRiskBanner()
        }
        this.creditResultDetail = data
        this.amountInfo = this.convertDetailResultAndInfo(this.creditResultDetail, this.info)
        this.$sensors.track('Results_Page_View', { page_status: this.result, product_code: configIds[0] })
        if (this.result === 'IN_HANDLE') {
          this.autoRefresh()
        } else {
          clearTimeout(this.autoRefreshTimer)
        }
      }
    },
    async getProductInfo () {
      const configIds = getKey('configIds')
      const { success, data } = await this.productInfo({
        configId: configIds[0],
        productInfo: false
      })
      if (success) {
        this.info = data || {}
      }
    },
    async init () {
      const applyNo = this.$route.query.applyNo
      if (applyNo) {
        this.getCreditResult()
      }
    },
    // 去借款
    borrowMoney (item = {}, index) {
      const { directionUrl, configId, productName, logo, configLimit, needExLogin, autoJump, diversionMode } = item
      this.$sensors.track('Diversion_Click', { product_type: 'diversion', page_status: this.step, element_positon: 'product_list', product_code: configId })
      // this.$report({
      //   id: 10269,
      //   args: {
      //     screen: this.type, status: 'borrowMoney', step: this.step, target: configId, type: index
      //   }
      // })
      this.$router.push({ path: '/river/middle', query: { directionUrl: encodeURIComponent(directionUrl), configId, productName, logo, source: encodeURIComponent(this.source), configLimit, needExLogin, autoJump, diversionMode } })
    },
    convertDetailResultAndInfo (detail, info) {
      const { availableAmount, creditLimit } = detail || {}
      const amountUpdateConfiged = availableAmount != null
      // 顶部状态标题
      const statusTitle = amountUpdateConfiged ? '可用额度(元)' : '授信额度(元)'
      // 顶部金额
      const statusAmount = amountUpdateConfiged ? this.formatMoney(availableAmount
      ) : this.formatMoney(creditLimit)
      return {
        amountUpdateConfiged,
        statusTitle,
        statusAmount
      }
    },
    async refreshAction () {
      clearTimeout(this.autoRefreshTimer)
      await this.init()
    },
    autoRefresh () {
      clearTimeout(this.autoRefreshTimer)
      this.autoRefreshTimer = setTimeout(() => {
        if (this.autoRefreshCount > 6) {
          clearTimeout(this.autoRefreshTimer)
        } else {
          this.autoRefreshCount++
          this.init()
        }
      }, 10000)
    },
    cardFlip () {
      this.cardFliped = !this.cardFliped
    },
    async backAction () {
      if (this.result === 'IN_HANDLE') {
        await this.refreshAction()
        if (this.result === 'IN_HANDLE') {
          // 没有授信结果，返回
          this.back()
        }
      } else if (this.shouldPopup) {
        // 审核被拒 && 展示风险查询用户且开关为开 && 没有展示过挽留弹窗
        // 展示挽留弹窗
        this.backPopVisible = true
        this.$sensors.track('PopupDisplay', { msg_name: '挽留弹窗：风险报告查询' })
        this.riskBackPopHasBeenShown = true
      } else {
        this.back()
      }
    },
    backToHome () {
      if (this.isAndroid && hasNativeMethod('exit')) {
        jsBridge('exit')
      } else {
        this.$router.push('/')
      }
    },
    checkBannerRiskReport () {
      if (this.riskBannerData.url) {
        window.location.href = this.riskBannerData.url
      }
    },
    async checkPopupRiskReport () {
      if (this.popupUrl) {
        window.location.href = this.popupUrl
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.api-auth {
  .home-button {
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 40px;
    margin-right: 30px;
    text-decoration:underline;
  }
  /deep/ .page {
    width: 750px;
    background: #fff;
    min-height: 100vh;
  }
  .recommend {
    margin-top: 50px;
    padding: 30px;
    .main-title {
      padding: 10px 30px;
    }
    .list-container {
      background: #F5F9FF;
      border-radius: 20px;
      padding: 30px 20px;
    }
  }
  .status {
    &.wait,&.fail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding-top: 90px;
      img {
        width:180px;
        height: 180px;
      }
      h2 {
        font-size: 42px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        margin-top: 45px;
        display: flex;
        align-items: center;
      }
      .risk-banner {
        width: 690px;
        height: 300px;
        margin-top: -60px;
        margin-bottom: 56px;
        background-color: #eee;
        border-radius: 20px;
        img {
          width: 100%;
          height: 100%;
        }
        img:not([src]){
          opacity:0;
        }
      }
      .expt {
        font-size: 26px;
        color: #666666;
        padding: 0 60px;
        margin-top: 15px;
        text-align: center;
        line-height: 37px;
      }
      .refresh {
        margin-top: 81px;
        width: 320px; height: 80px;
        line-height: 80px;
        border: 2px solid #ff4633;
        border-radius: 40px;
        text-align: center;
        font-size: 32px;
        color: #ff4633;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
    &.wait {
      margin-bottom: 80px;
      .wait-lottie {
        width: 210px !important;
        height: 210px !important;
      }
    }
    &.success {
      .card {
        width: 690px;
        height: 760px;
        margin: 0 auto 10px;
        transform-style: preserve-3d;
        transition: transform 0.6s;
        .front {
          position: absolute;
          backface-visibility: hidden;
          padding: 40px 40px;
          background: #f7f7f7;
          border-radius: 20px;
          .info-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title {
              font-size: 50px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333;
              line-height: 70px;
              white-space: nowrap;
            }
            img {
              margin-left: 6px;
            }
          }
          .bottom-tip {
            font-size: 28px;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #333333;
          }
          .info, .invalid {
            background: #fff;
            width: 610px;
            height: 330px;
            margin-top: 34px;
            border-radius: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .status-title {
              margin-top: 49px;
              font-size: 24px;
            }
            .status-amount {
              margin-top: -10px;
              font-size: 100px;
              font-family: DIN-Medium, DIN;
              font-weight: 500;
            }
            .credit-amount {
              font-size: 24px;
              color: #666;
              margin-top: 22px;
              height: 33px;
            }
            .bottom-tags {
              display: flex;
              justify-content: space-around;
              font-size: 24px;
              color: #666;
              margin: 17px auto;
              width: 100%;
              &.noCreditAmount {
                margin: 72px auto;
              }
              .tag {
                text-align: center;
              }
            }
          }
          .invalid {
            justify-content: center;
          }
          .withdraw-btn {
            margin-top: 40px;
            width: 100%;
            height: 94px;
            line-height: 94px;
            text-align: center;
            border-radius: 47px;
            color: #fff;
            font-size: 32px;
            background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
            &.disabled {
              opacity: 0.5;
            }
          }
        }
        .back {
          position: absolute;
          backface-visibility: hidden;
          transform: rotateY(180deg);
        }
        &.isBack {
          transform: rotateY(180deg);
        }
      }
      .footer-txt {
        position: fixed;
        bottom: 80px;
        left: 0;
        right: 0;
        color: #666;
        text-align: center;
        font-size: 24px;
        color: #999;
      }
    }
  }

  .withdraw-btn {
    width: 460px;
    margin:0 auto 75px auto;
  }
  .tral {
    display: flex;
    justify-content: space-between;
    margin:30px ;
    background: #fff;
    padding: 45px;
    border-radius: 20px;
    align-items: center;
    &.wait {
      background: #EBF0F9;
      border-radius: 20px;
       .break {
        background: #fff;
       }
    }
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      p {
        font-size: 36px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        margin-top: 10px;
      }
    }
    .break {
      width: 2px;
      height: 50px;
      background: #cccccc;
      border-radius: 5px;
    }
  }

  .recomment {
    .item {
      background: #FFFFFF;
      border-radius: 20px;
      margin:30px auto ;
      padding: 30px;

      .header {
        display: flex;
        height: 90px;
        align-items: center;
        border-bottom: 1px solid #eee;
        img {
          width: 48px;
          height: 48px;
          margin-right: 10px;
        }
        .name {
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
        .info {
          flex:1;
          font-size: 20px;
          text-align: right;
          .danger {
            color: #FF4633;
          }
        }
        .content {
          display: flex;
          flex-direction: column;
          padding: 10px 0;
          height: 180px;
          justify-content: space-around;
          .name {
            font-size: 24px;
          }
          .amount {
            font-size: 40px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
          }
          .exp {
            color: #999;
            font-size: 24px;
          }
        }
      }
    }
  }

  .risk-pop {
    width: 620px;
    height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .title{
      font-size: 42px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 72px;
      text-align: center;
      margin-top: -40px;
     }
     .content {
      width: 520px;
      height: 103px;
      // margin-bottom: 62px;
     }
     .check-button {
      width: 320px;
      height: 80px;
     }
  }

}
</style>
